import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";
import { EmployeeDocumentCategoryDto } from "@/core/features/employee-document-categories/employee-document-category.dto";
import { EmployeeDocumentReviewStatusEnum } from "@/core/features/employee-documents/employee-document-review-status.enum";

export class EmployeeOnboardingUploadRequirementDto extends BaseEntityDto {
  processId: string;
  categoryId: string;
  isRequired: boolean;
  isSelected: boolean;
  sortOrder: number;
  isCurrentDocumentValid: boolean;
  latestReviewStatus?: EmployeeDocumentReviewStatusEnum | null;
  reviewMessage?: string | null;

  @Type(() => EmployeeDocumentCategoryDto)
  category: EmployeeDocumentCategoryDto;
}
